export const Content = 'Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups'

export const Paragraph = {
  title: 'Paragraph Title',
  description: `<p>${Content}</p>`,
  theme: 'lightGray',
  size: 'sub-desk',
}

export const Image = (url = 'https://images.unsplash.com/5/unsplash-kitsune-4.jpg') => ({
  type: 'Image',
  data: {
    id: 140,
    attributes: {
      name: 'hero_sample.jpg',
      alternativeText: 'hero_sample.jpg',
      caption: 'hero_sample.jpg',
      width: 1440,
      height: 810,
      formats: {
        thumbnail: {
          name: 'thumbnail_hero_sample.jpg',
          hash: 'thumbnail_hero_sample_9cd783dbf0',
          ext: '.jpg',
          mime: 'image/jpeg',
          path: null,
          width: 245,
          height: 137,
          size: 4.56,
          url: `${url}?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjEyMDd9&s=fb86e2e09fceac9b363af536b93a1275thumbnail_hero_sample_9cd783dbf0.jpg`
        },
        large: {
          name: 'large_hero_sample.jpg',
          hash: 'large_hero_sample_9cd783dbf0',
          ext: '.jpg',
          mime: 'image/jpeg',
          path: null,
          width: 1000,
          height: 563,
          size: 33.18,
          url: `${url}?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjEyMDd9&s=fb86e2e09fceac9b363af536b93a1275large_hero_sample_9cd783dbf0.jpg`
        },
        medium: {
          name: 'medium_hero_sample.jpg',
          hash: 'medium_hero_sample_9cd783dbf0',
          ext: '.jpg',
          mime: 'image/jpeg',
          path: null,
          width: 750,
          height: 422,
          size: 22.01,
          url: `${url}?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjEyMDd9&s=fb86e2e09fceac9b363af536b93a1275medium_hero_sample_9cd783dbf0.jpg`
        },
        small: {
          name: 'small_hero_sample.jpg',
          hash: 'small_hero_sample_9cd783dbf0',
          ext: '.jpg',
          mime: 'image/jpeg',
          path: null,
          width: 500,
          height: 281,
          size: 12.48,
          url: `${url}?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjEyMDd9&s=fb86e2e09fceac9b363af536b93a1275small_hero_sample_9cd783dbf0.jpg`
        }
      },
      hash: 'hero_sample_9cd783dbf0',
      ext: '.jpg',
      mime: 'image/jpeg',
      size: 54.76,
      url: `${url}?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjEyMDd9&s=fb86e2e09fceac9b363af536b93a1275`,
      previewUrl: null,
      provider: 'strapi-provider-upload-aws-s3-advanced',
      provider_metadata: null,
      createdAt: '2022-05-13T13:01:21.868Z',
      updatedAt: '2022-05-13T13:01:21.868Z'
    }
  },
})

export const ParagraphWithImage = {
  ...Paragraph,
  title: 'Paragraph with image',
  image: Image()
}


export const TagList = { data: ['Junior', 'HTML', 'CSS'] }


export const Link = {
  type: 'Link',
  label: 'Link label',
  href: '/url-to-content',
  target: '_self'
}


export const ServiceCard = {
  link: Link,
  title: 'End-to-End Logistics',
  excerpt: 'Logistica by T-Data dallo stoccaggio alla consegna al cliente finale',
  icon: 'endToEnd'
}


export const NewsPreview = {
  link: Link,
  title: 'Fatturazione elettronica per e-commerce',
  excerpt: 'Il sistema di fatturazione elettronica è stato introdotto con l’obiettivo di organizzare in modo più efficace le procedure di emissione, trasmissione e conservazione delle fatture, semplificando i sistemi di transazione, tra cui anche quelle online.'
}

export const JobPreview = {
  link: Link,
  title: 'Software Developer Junior',
  excerpt: 'Se sei un appassionato/a di tecnologie IT innovative e vuoi entrare a far parte di un ambiente di lavoro giovane e stimolante, questa è la tua occasione!',
  tags: TagList
}

export const CardContent = {
  title: 'Orientamento al cliente',
  content: 'La soddisfazione del cliente rappresenta per noi il modo migliore per creare valore. Per questo è il nostro obiettivo principale. '
}


export const ImageMosaic = [
  {
    id: 1,
    attributes: {
      title: 'title 1',
      image: {
        media: { ...Image() },
        cursor: {
          type: 'defaultLink',
          text: 'Scopri di più',
          blendMode: 'normal',
        },
        cta: {
          label: 'Marketplace support', theme: 'inverted'
        },
        ...Link
      }
    }
  },
  {
    id: 2,
    attributes: {
      title: 'title 2',
      image: {
        media: { ...Image() },
        cursor: {
          type: 'defaultLink',
          text: 'Scopri di più',
          blendMode: 'normal',
        },
        cta: {
          label: 'Marketplace support', theme: 'inverted'
        },
        ...Link
      }
    }
  },

  {
    id: 3,
    attributes: {
      title: 'title 3',
      image: {
        media: { ...Image() },
        cursor: {
          type: 'defaultLink',
          text: 'Scopri di più',
          blendMode: 'normal',
        },
        cta: {
          label: 'Marketplace support',
          theme: 'inverted'
        },
        ...Link
      }
    }
  }
]

export const ContentWithSlider =  {
  type: 'ContentWithSlider',
  title: "Gli inizi",
  description: "Qui inizia la storia dei Montecchi: sulla strada, quella di un tempo, piena di pozzanghere d'inverno, piena di polvere secca d'estate. E questa strada è quella di Pavullo, nell’Appennino Emiliano in provincia di Modena, un paesello adagiato su un piccolo altopiano circondato da boschi di abeti e querce e punteggiato da case dai coppi rossi e ocra. A partire dal 1850, in località Quercia Grossa, Domenico Montecchi trasporta ogni sorta di merci utilizzando un carro biroccio trainato da un grande cavallo da tiro. Così ha inizio un'attività che ha perseverato di generazione in generazione e che ha continuato a crescere insieme alla tecnologia, all'Italia e al mondo. Qui inizia la storia dei Montecchi: sulla strada, quella di un tempo, piena di pozzanghere d'inverno, piena di polvere secca d'estate. E questa strada è quella di Pavullo, nell’Appennino Emiliano in provincia di Modena, un paesello adagiato su un piccolo altopiano circondato da boschi di abeti e querce e punteggiato da case dai coppi rossi e ocra. A partire dal 1850, in località Quercia Grossa, Domenico Montecchi trasporta ogni sorta di merci utilizzando un carro biroccio trainato da un grande cavallo da tiro. Così ha inizio un'attività che ha perseverato di generazione in generazione e che ha continuato a crescere insieme alla tecnologia, all'Italia e al mondo.",
  slides: [
    {
      id: "1",
      image: 'https://images.unsplash.com/5/unsplash-kitsune-4.jpg',
      resizeMode: "cover"
    },
    {
      id: "2",
      image: 'https://images.unsplash.com/photo-1685355733649-c5dfae41e667?q=80&w=3087&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      resizeMode: "cover"
    },
    {
      id: "3",
      image: 'https://images.unsplash.com/5/unsplash-kitsune-4.jpg',
      resizeMode: "cover"
    }
  ]
}